(function () {
  if (window.nbCsReady) return;
  window.nbCsReady = true;

  function addUrl() {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  }

  function swap(html, targetSel, innerSel) {
    if (!html) return;
    var target = document.querySelector(targetSel);
    if (!target) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector(innerSel) || tmp.firstElementChild;
    if (fresh) target.innerHTML = fresh.innerHTML;
  }

  function refresh(data) {
    if (!data || !data.sections) return;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections['cart-drawer']) {
      swap(data.sections['cart-drawer'], '#CartDrawer', '#CartDrawer');
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }

    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id && data.sections[main.dataset.id]) {
      swap(data.sections[main.dataset.id], '#main-cart-items .js-contents', '.js-contents');
      var footer = document.getElementById('main-cart-footer');
      if (footer && footer.dataset.id && data.sections[footer.dataset.id]) {
        swap(data.sections[footer.dataset.id], '#main-cart-footer .js-contents', '.js-contents');
      }
    }

    if (data.sections['cart-icon-bubble']) {
      swap(data.sections['cart-icon-bubble'], '#cart-icon-bubble', '#cart-icon-bubble');
    }

    document.dispatchEvent(new CustomEvent('nb:cart-updated', { bubbles: true }));
    bindRails();
  }

  function sectionList() {
    var list = [];
    if (document.querySelector('cart-drawer')) list.push('cart-drawer');
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id) list.push(main.dataset.id);
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) list.push(footer.dataset.id);
    list.push('cart-icon-bubble');
    return list;
  }

  /* ---------- Cambio de variante ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sel = t.closest('[data-nb-cs-select]');
    if (!sel) return;
    var card = sel.closest('.nb-cs__card');
    if (!card) return;
    var btn = card.querySelector('[data-nb-cs-add]');
    if (!btn) return;
    var opt = sel.options[sel.selectedIndex];
    btn.dataset.vid = sel.value;
    btn.disabled = !!(opt && opt.disabled);
  });

  /* ---------- Agregar al carrito ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-nb-cs-add]');
    if (!btn || btn.disabled) return;

    e.preventDefault();

    var id = Number(btn.dataset.vid);
    if (!id) return;

    var label = btn.dataset.label || btn.textContent;
    var ok = btn.dataset.ok || 'Agregado';

    btn.disabled = true;
    btn.textContent = '…';

    fetch(addUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript'
      },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: sectionList(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.disabled = false;
          btn.textContent = label;
          return;
        }
        btn.classList.add('is-ok');
        btn.textContent = ok;
        setTimeout(function () { refresh(data); }, 450);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });

  /* ---------- Flechas del carrusel ---------- */
  function railOf(el) {
    var wrap = el.closest('[data-nb-cs]');
    return wrap ? wrap.querySelector('[data-nb-cs-rail]') : null;
  }

  function step(rail, dir) {
    if (!rail) return;
    var card = rail.querySelector('.nb-cs__card');
    var w = card
      ? Math.round(card.getBoundingClientRect().width) + 12
      : Math.round(rail.clientWidth * 0.8);
    var max = rail.scrollWidth - rail.clientWidth;
    var target = rail.scrollLeft + (w * dir);
    if (target < 0) target = 0;
    if (target > max) target = max;

    try {
      rail.scrollTo({ left: target, behavior: 'smooth' });
    } catch (err) {
      rail.scrollLeft = target;
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-nb-cs-prev], [data-nb-cs-next]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    step(railOf(btn), btn.hasAttribute('data-nb-cs-prev') ? -1 : 1);
  });

  /* ---------- Estado de las flechas ---------- */
  function syncArrows(wrap) {
    var rail = wrap.querySelector('[data-nb-cs-rail]');
    var prev = wrap.querySelector('[data-nb-cs-prev]');
    var next = wrap.querySelector('[data-nb-cs-next]');
    if (!rail || !prev || !next) return;

    var max = rail.scrollWidth - rail.clientWidth;
    if (max <= 4) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }
    prev.disabled = rail.scrollLeft <= 4;
    next.disabled = rail.scrollLeft >= max - 4;
  }

  function bindRails() {
    document.querySelectorAll('[data-nb-cs]').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-nb-cs-rail]');
      if (!rail || rail.dataset.nbBound === 'true') return;
      rail.dataset.nbBound = 'true';
      rail.addEventListener('scroll', function () { syncArrows(wrap); }, { passive: true });
      syncArrows(wrap);
      setTimeout(function () { syncArrows(wrap); }, 400);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindRails);
  } else {
    bindRails();
  }

  new MutationObserver(bindRails).observe(document.body, { childList: true, subtree: true });
})();